module.exports = __webpack_public_path__ + "static/media/header-mobile.7428ed4a.svg";